import { render, staticRenderFns } from "./coReactions.vue?vue&type=template&id=14803429&scoped=true&"
import script from "./coReactions.vue?vue&type=script&lang=ts&"
export * from "./coReactions.vue?vue&type=script&lang=ts&"
import style0 from "./coReactions.vue?vue&type=style&index=0&id=14803429&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14803429",
  null
  
)

export default component.exports